/**
 * Entrada do frontend React do Report Viewer (spec 0009).
 *
 * O `styles.css` do design system entra UMA vez, aqui: ele traz as fontes, os tokens e um reset
 * global que mexe em `body`, titulos e controles nativos.
 */

import '@ledger-glass/react/styles.css'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // O catalogo muda pouco dentro de uma sessao; refetch por foco traria uma consulta ao Auth e
      // ao Report Manager so por trocar de aba.
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

const root = document.getElementById('root')
if (root === null) throw new Error('Elemento #root nao encontrado no index.html.')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
